function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgEnglish = function SvgEnglish(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256"
  }, props), /*#__PURE__*/React.createElement(G, {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    }
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M88.35 57.052c.034-.123.076-.243.109-.367l-.004-.002a44.9 44.9 0 0 0 .007-23.34l.004-.002c-.039-.146-.088-.289-.128-.434a43 43 0 0 0-.434-1.468q-.123-.385-.253-.768c-.073-.217-.139-.437-.215-.653h-.015a44.9 44.9 0 0 0-7.01-12.768L59.997 27.458V2.57A44.9 44.9 0 0 0 46.082.028h-2.164a44.9 44.9 0 0 0-13.913 2.541v24.889L9.589 17.249a44.9 44.9 0 0 0-7.01 12.769h-.015c-.076.216-.143.436-.216.653q-.13.382-.253.765-.23.73-.434 1.47c-.04.145-.089.287-.128.432l.004.002a45 45 0 0 0 .008 23.344l-.004.002c.033.123.074.242.108.365q.217.787.462 1.562.113.353.233.705c.077.231.148.464.229.693h.017a44.9 44.9 0 0 0 7.016 12.761l20.4-10.2v24.86A44.9 44.9 0 0 0 45 90c5.26 0 10.305-.911 14.997-2.57V62.572l20.398 10.199a44.9 44.9 0 0 0 7.015-12.76h.015c.081-.229.152-.463.23-.694q.12-.35.233-.704.245-.776.462-1.561",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#f3f4f5",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.407 1.407)scale(2.81)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M53.999.902a45 45 0 0 0-7.917-.874h-2.164a45 45 0 0 0-7.914.874v35.116H.899A45 45 0 0 0 0 45c0 3.087.312 6.1.904 9.012h35.1v35.087A45 45 0 0 0 45 90c3.082 0 6.091-.311 8.999-.902V54.012h35.097C89.688 51.1 90 48.087 90 45c0-3.076-.311-6.08-.899-8.983H53.999z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#c00",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.407 1.407)scale(2.81)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M85.242 65.135a45 45 0 0 0 2.184-5.125H74.993zM82.216 19.701 61.581 30.019h13.412l10.261-5.131a45 45 0 0 0-3.038-5.187M4.747 24.887a45 45 0 0 0-2.182 5.132H15.01zM7.8 70.321 28.422 60.01H15.01L4.758 65.136A45 45 0 0 0 7.8 70.321",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#c00",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.407 1.407)scale(2.81)"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "m9.589 17.249 20.416 10.208V2.584A45.07 45.07 0 0 0 9.589 17.249M59.997 2.585v24.872L80.411 17.25A45.06 45.06 0 0 0 59.997 2.585M30.006 72.77V62.572l-20.4 10.2a45.07 45.07 0 0 0 20.4 14.646zM59.997 62.572v24.844A45.07 45.07 0 0 0 80.395 72.77z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "#006",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.407 1.407)scale(2.81)"
  })));
};
export default SvgEnglish;